import React, { useState, useEffect } from 'react';
import {
  Modal,
  Button,
  Form,
  InputGroup,
  ListGroup,
  Spinner,
} from 'react-bootstrap';
import { notify } from 'react-notify-toast';
import clientAxios from '../../../../clients/clientAxios';
import { searchClassroomByName } from '../../../../helpers/searchClassRoomByName';

const MigrationStudent = ({
  showMigrationModal,
  onClose,
  currentClassroom,
  studentId,
  studentName,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchClassroomResults, setSearchClassroomResults] = useState([]);
  const [isLoadingSearchResults, setIsLoadingSearchResults] = useState(false);
  const [isSearchResultsVisible, setIsSearchResultsVisible] = useState(false);
  const [selectedClassroom, setSelectedClassroom] = useState(null);
  const [showMigrationConfirmModal, setShowMigrationConfirmModal] =
    useState(false);
  const [isMigrating, setIsMigrating] = useState(false);
  const [isSearchTriggeredBySelect, setIsSearchTriggeredBySelect] =
    useState(false);
  
  useEffect(() => {
    if (isSearchTriggeredBySelect) {
      setIsSearchTriggeredBySelect(false);
      return;
    }
    if (searchValue.length >= 2) {
      searchClassroomByName(
        setIsLoadingSearchResults,
        setSearchClassroomResults,
        searchValue,
        true
      );
      setIsSearchResultsVisible(true);
    } else {
      setSearchClassroomResults([]);
      setIsSearchResultsVisible(false);
    }
  }, [searchValue]);

  const handleSelectClassroom = (classroom) => {
    setIsSearchTriggeredBySelect(true);
    setSelectedClassroom(classroom);
    setSearchValue(classroom.classroom);
    setIsSearchResultsVisible(false);
  };

  const handleCloseAll = (refresh = false) => {
    setSearchValue('');
    setSelectedClassroom(null);
    setSearchClassroomResults([]);
    setShowMigrationConfirmModal(false);
    onClose(refresh);
  };

  const migrate = async () => {
    setIsMigrating(true);
    try {
      const { data } = await clientAxios.post(
        `/classroom/promote/student/${studentId}`,
        {
          fromClassroomId: currentClassroom?._id,
          toClassroomId: selectedClassroom?._id,
          userId: studentId,
        }
      );

      if (Array.isArray(data?.success) && data.success.length > 0) {
        notify.show('Migración realizada con éxito', 'success');
        handleCloseAll(true);
      } else if (Array.isArray(data?.failed) && data.failed.length > 0) {
        notify.show(`No se pudo migrar: ${data.failed.join(', ')}`, 'error');
        handleCloseAll(true);
      } else {
        notify.show('No se pudo migrar alumno', 'error');
      }
    } catch (error) {
      notify.show('Error al migrar alumno', 'error');
    } finally {
      setIsMigrating(false);
    }
  };

  return (
    <>
      <Modal
        show={showMigrationModal}
        onHide={() => handleCloseAll(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Migrar alumno a otra comisión</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Comisión actual:{' '}
            <strong>
              <span>{currentClassroom?.classroom}</span>
            </strong>
          </p>

          <Form.Group className="mb-0">
            <Form.Label>Buscar nueva comisión</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <i className="fa fa-search" />
              </InputGroup.Text>
              <Form.Control
                placeholder="Nombre de la comisión"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </InputGroup>

            {isSearchResultsVisible && (
              <ListGroup
                style={{
                  position: 'absolute',
                  zIndex: 10,
                  width: '100%',
                }}
              >
                {isLoadingSearchResults ? (
                  <ListGroup.Item className="text-center">
                    <Spinner animation="border" size="sm" />
                  </ListGroup.Item>
                ) : (
                  searchClassroomResults.map((classroom) => (
                    <ListGroup.Item
                      key={classroom._id}
                      action
                      onClick={() => handleSelectClassroom(classroom)}
                    >
                      {classroom.classroom}
                    </ListGroup.Item>
                  ))
                )}
              </ListGroup>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseAll(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            disabled={
              !selectedClassroom ||
              selectedClassroom?._id === currentClassroom?._id
            }
            onClick={() => setShowMigrationConfirmModal(true)}
          >
            Migrar alumno
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showMigrationConfirmModal}
        onHide={() => setShowMigrationConfirmModal(false)}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar migración</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">
            ¿Está seguro que desea migrar al alumno{' '}
            <strong>
              <span>{studentName}</span>
            </strong>{' '}
            y todos sus pagos de la comisión{' '}
            <strong>
              <span>{currentClassroom?.classroom}</span>
            </strong>{' '}
            a la comisión{' '}
            <strong>
              <span>{selectedClassroom?.classroom}</span>
            </strong>
            ?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowMigrationConfirmModal(false)}
            disabled={isMigrating}
          >
            Cancelar
          </Button>
          <Button variant="primary" onClick={migrate} disabled={isMigrating}>
            {isMigrating && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                className="me-2"
              />
            )}
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MigrationStudent;
